/**
 *  Module containing functions that are used globally
 *
 *
 */

export function styleForm() {
  this.init = function () {
    $("li.labeled").each(function () {
      var _THIS = $(this);
      try {
        if (_THIS.find("input,textarea").val().length > 0) {
          _THIS.addClass("focused");
        }
      } catch (err) {}
    });

    $("li.labeled").click(function () {
      if ($(this).find("input,textarea").val().length == 0) {
        $(this).addClass("focused");
        $(this).find("input,textarea").focus();
      }
    });
    $("li.labeled input, li.labeled textarea").focus(function () {
      $(this).parents(".labeled").addClass("focused");
    });
    $("li.labeled input, li.labeled textarea").blur(function () {
      if ($(this).val().length == 0) {
        if (!$(this).parent().hasClass("only")) {
          $(this).parent().removeClass("focused");
          $(this).parent().parent().removeClass("focused");
        }
      }
    });
  };
}

/** Main Menu Activation  */
export function menu() {
  this.init = function () {
    var instHeadMiniCart = new miniCart();

    let navbar = document.getElementById("shopify-section-header");
    let navOffset = navbar.offsetTop;
    window.addEventListener("scroll", () => {
      if($("#site-icons .mobile").is(":hidden")){
      if (window.scrollY >= 150) {
        navbar.classList.add("fixed-header");
        document.body.classList.add("scroll-header");
      } else {
        navbar.classList.remove("fixed-header");
        document.body.classList.remove("scroll-header");
      }
      }
    });
    
    $(window).on("resize", function () {
      var windowWidth = $(window).width();
      if (windowWidth >= 1024) {
        if ($("#main-menu").hasClass("active")) {
          $("#mob-site-icons .menu-icon").trigger("click");
        }
        $("#site-search-mob").css("display", "none");
        $("body").removeClass("search-active");
      }
    });

    $(".search_m").click(function (e) {
      e.preventDefault();
      $("#site-search-mob").slideToggle("slow");
      $("body").toggleClass("search-active");
    });

    /*$(".search_m").click(function(e){
            e.preventDefault();
            $("#search-input input").trigger('click');
        });*/
    /** Close the menu  */
    $(".menu-icon, #main-menu #menu-close, .menu-overlay").click(function () {
      $("#main-menu").toggleClass("active");
      $("#menu-sub").find(".active-menu").removeClass("active-menu");
      $(this).removeClass("active");
      $("body").toggleClass("menu-active");
      $("#main-menu")
        .find(".active-sub-menu-item")
        .removeClass("active-sub-menu-item");
      $("#main-menu").find(".active-sub-menu").removeClass("active-sub-menu");
      $("#main-menu").find(".mob-active-menu").removeClass("mob-active-menu");
      $("#main-menu").find(".mob-activeMenu").removeClass("mob-activeMenu");
      $("#main-menu").find(".sub-menu-active").removeClass("sub-menu-active");
      $("#main-menu").find(".subMenu-active").removeClass("subMenu-active");
      $("#main-menu").find(".back-active").removeClass("back-active");
      $("#menu-header").removeClass("active");
    });
    /** Mobile menu */
    $(window).on("resize load", function () {
      var windowWidth = $(window).width();
      if (windowWidth <= 1024) {
        $(document).off("click", "#main-menu .dropdown");
        $(document).off("click", "#main-menu .menu-heading");
        $(document).off("click", "#main-menu a");
        $(document).on("click", "#main-menu .dropdown", function (e) {
          //console.log("click"); console.log($(this).children().length);
          if ($(this).children().length != 0) {
            e.stopPropagation();
            e.preventDefault();
            //$(this).unbind('mouseenter mouseleave');
            var attr = $(this).attr("data-menu");
            if (typeof attr !== typeof undefined && attr !== false) {
              e.preventDefault();
              $("#" + attr + "-menu").toggleClass("mob-active-menu");
              $("#" + attr + "-menu")
                .parent()
                .toggleClass("mob-activeMenu");
              $("#menu-header").toggleClass("back-active");
              $("#menu-back").attr("data-menu-item", attr + "-menu");
              $("#menu-back .sub-title").text($(this).find("a:first").text());
            }
          }
        });

        $(document).on("click", "#main-menu .menu-heading", function (e) {
          //console.log("clk"); console.log($(this).children().length);
          if ($(this).children().length != 0) {
            e.stopPropagation();
            var attr = $(this).find("a:first").attr("data-menu");
            if (typeof attr !== typeof undefined && attr !== false) {
              e.preventDefault();
              $("#" + attr + "-menu").toggleClass("mobSub-active-menu");
              $("#" + attr + "-menu")
                .parent()
                .toggleClass("mobSub-activeMenu");
              $("#menu-back").attr("data-sub-item", attr + "-menu");
              $("#menu-back .sub-title").text($(this).find("a:first").text());
            }
          }
        });

        $("#main-menu a").click(function (e) {
          console.log($(this).parent().children().length);
          if ($(this).parent().children().length == 1) {
            e.stopPropagation();
            return true;
          }
        });
      }
    });
    /** Promotion images click */
    $(".promoImg").click(function(e){
      var link = $(this).attr("href");
      $("#mob-site-icons .menu-icon").trigger("click");
       window.location.replace(link);
      });
    /** Mobile menu back button */
    $("#menu-back").click(function (e) { 
      e.stopPropagation();
      var submenuId = $(this).attr("data-sub-item");
      var menuId = $(this).attr("data-menu-item");
      if (typeof submenuId !== typeof undefined && submenuId !== false) {
        $("#" + submenuId).toggleClass("mobSub-active-menu");
        $("#" + submenuId)
          .parent()
          .toggleClass("mobSub-activeMenu");
        var menuName = menuId.split("-")[0];
        console.log(menuName);
        $("#menu-back .sub-title").text(
          $("[data-menu=" + menuName + "]")
            .find("a:first")
            .text()
        );
        $("#menu-back").removeAttr("data-sub-item");
      } else if (typeof menuId !== typeof undefined && menuId !== false) {
        $("#" + menuId).toggleClass("mob-active-menu");
        $("#" + menuId)
          .parent()
          .toggleClass("mob-activeMenu");
        $("#menu-header").toggleClass("back-active");
        $("#menu-back .sub-title").text("");
      }
    });
    /*** Desktop Mega Menu - Used hoverIntent to pause the navigation for few seconds */
    $(document).ready(function(){
      var config = {
        sensitivity: 3, // number = sensitivity threshold (must be 1 or higher)
        interval: 200, // number = milliseconds for onMouseOver polling interval
        timeout: 10, // number = milliseconds delay before onMouseOut
        over: function () { 
        var _This = $(this);
        //setTimeout(function(){
        if ((!$(".active#main-menu")[0]) && (!$(".menu-active#main-menu")[0])) {
          $("#main-menu").addClass("menu-active");
          var attr = _This.attr("data-menu"); //console.log("In "+attr);
          if (typeof attr !== typeof undefined && attr !== false) {
            $("#" + attr + "-menu").addClass("sub-menu-active");
            $("#" + attr + "-menu")
              .parent()
              .addClass("subMenu-active");
              _This.addClass("active");
          }
        }
      //}, 500);
      },
      out: function () { 
        var _This = $(this);
        if ($(".menu-active#main-menu")[0]) {
          $("#main-menu").removeClass("menu-active");
          var attr = _This.attr("data-menu");  //console.log("out "+attr);
          if (typeof attr !== typeof undefined && attr !== false) {
            $("#" + attr + "-menu").removeClass("sub-menu-active");
            $("#" + attr + "-menu")
              .parent()
              .removeClass("subMenu-active");
              _This.removeClass("active");
          }
        }
      }
    };
    $(".dropdown").hoverIntent(config);
  });
  /** Mini Cart display */
    $(document).on("click", "#mini-cart-icon", function (e) {
      e.preventDefault();

      if (!$(document.body).hasClass("template-cart")) {
        if ($(this).hasClass("has-items")) {
          instHeadMiniCart.init();
          instHeadMiniCart.toggleDisplayMiniCart();
        }
      }
    });
  };
}

/* Promtion Bar */
export function promotionHeader() {
  var _THIS = this;

  this.init = function () {
    $(window).on("resize load", function () {
      _THIS.registerEvents();
    });
  };

  this.registerEvents = function () {
    var windowWidth = $(window).width();
    if (windowWidth >= 1024) {
      $("#promotion-slider")
        .not(".slick-initialized")
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          arrows: false,
          fade: true,
         /* mobileFirst: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: "unslick",
            },
          ], */
        });
    } 
    else {
      var clsExist = $(".slick-slider")[0];
      if (clsExist) {
        $("#promotion-slider").slick("unslick");
      }
    }
  };
}

/* Header Promtion Bar Bottom*/
export function heroPromotionHeader() {
  var _THIS = this;

  this.init = function () {
    $(window).on("resize load", function () {
      _THIS.registerEvents();
    });
  };

  this.registerEvents = function () {
    $("#hero-promotion-slider")
        .not(".slick-initialized")
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          arrows: false,
          vertical: true,
          verticalSwiping: true
        });
  };
}

/* Promtion Bar Body*/
export function heroPromotionBody() {
  var _THIS = this;

  this.init = function () {
    $(window).on("resize load", function () {
      _THIS.registerEvents();
    });
  };

  this.registerEvents = function () {
    $("#body-promotion-slider")
        .not(".slick-initialized")
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          arrows: false,
          vertical: true,
          verticalSwiping: true
        });
  };
}

export function headerBagIcon() {
  var _THIS = this;
  this.updateBagIcon = function (cartItems) {
    if (cartItems == null) {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (cart) {
        refreshBagIcon(cart.item_count);
      });
    } else {
      refreshBagIcon(cartItems);
    }
  };

  var refreshBagIcon = function (itemCount) {
    if (itemCount > 0) {
      $("#mini-cart-icon").addClass("has-items");
      $("#mini-cart-icon .cart-num").text(itemCount);
      $(".mini-cart-num").text(itemCount);
    } else {
      $("#mini-cart-icon").removeClass("has-items");
      $("#mini-cart-icon .cart-num").text(0);
      $(".mini-cart-num").text(0);
    }
  };
}

export function miniCart() {
  var _THIS = this;
  _THIS.cartData = null;
  _THIS.targetElement = null;
  _THIS.instHeaderIcon = null;
  this.init = function () {
    if ($("#mini-cart").hasClass("initialised")) {
      return;
    } else {
      $("#mini-cart").addClass("initialised");
      registerEvents();
    }
  };

  var registerEvents = function () {
    $(document).on("click", "#mini-cart-close", function (e) {
      e.preventDefault();
      _THIS.hideMiniCart();
    });

    $(document).on("click", ".mini-cart-overlay", function (e) {
      e.preventDefault();
      _THIS.hideMiniCart();
    });

    $(document).on("click", "#mini-cart .mini-cart-prod-remove", function (e) {
      e.preventDefault();

      var objArg = {};

      var getCartItemID = $(this)
        .closest(".cart-line-item")
        .attr("data-item-id");
      objArg.itemid = getCartItemID;

      if (typeof getCartItemID !== "undefined") {
        sendG4Event("remove_from_cart", objArg);
      }
      removeMiniCartItem(
        $(this).closest(".cart-line-item").attr("data-line-item-key")
      );
    });
  };

  var removeMiniCartItem = function (lineitemid) {
    $("#mini-cart").addClass("minicart-updating");

    $("#mini-cart-loader").removeClass("hide");

    $(
      "#mini-cart .cart-line-item[data-line-item-key='" + lineitemid + "']"
    ).addClass("removing");

    let formData = {
      id: lineitemid,
      quantity: 0,
    };
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        _THIS.cartData = data;
        _THIS.updateMiniCart(lineitemid);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  this.toggleDisplayMiniCart = function () {
    if (!$("#mini-cart").hasClass("active")) {
      _THIS.showMiniCart();
    } else {
      _THIS.hideMiniCart();
    }
  };

  this.getCartSectionHTML = function (callback) {
    $.getJSON(
      window.Shopify.routes.root + "?sections=mini-cart-content",
      function (cartcontent) {
        if (callback != null) return callback.call(this, cartcontent);
      }
    );
  };

  this.showMiniCart = function () {
    $("#mini-cart").addClass("active");
    $("body").addClass("mini-cart-active");
    $("body").removeClass("menu-active");

    $("#main-menu").removeClass("active");

    _THIS.getCartSectionHTML(function (content) {
      $("#mini-cart .mini-cart-inner-wrapper").html(
        content["mini-cart-content"]
      );
    });

    jQuery.getJSON("/cart.js", function (cart) {
      _THIS.cartData = cart;
    });
  };

  this.hideMiniCart = function () {
    $("#mini-cart").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("mini-cart-active");
    }, 1000);
  };
  this.updateMiniCart = function (lineitemid) {
    //console.log( _THIS.cartData)

    $("#mini-cart").removeClass("minicart-updating");
    $("#mini-cart-loader").addClass("hide");
    // $("#mini-cart .cart-line-item[data-line-item-key='" + lineitemid  + "']").removeClass("removing").remove();
    if (_THIS.instHeaderIcon == null) {
      _THIS.instHeaderIcon = new headerBagIcon();
    }

    _THIS.instHeaderIcon.updateBagIcon(_THIS.cartData.item_count);
    _THIS.getCartSectionHTML(function (content) {
      $("#mini-cart .mini-cart-inner-wrapper").html(
        content["mini-cart-content"]
      );
    });

    if (_THIS.cartData.item_count <= 0) {
      _THIS.hideMiniCart();
    } else {
    }
  };
}

export function emailValidate() {
  var _THIS = this;
  this.emailRetryCounter = 0;
  this.init = function (emailfield, inpsubmit, pcallback) {
    var label =
      emailfield.attr("name").split("[").join("-").split("]").join("") || "";
    emailfield.bind("blur", function () {
      if (emailfield.val().length <= 0) {
        emailfield.removeClass("valid").addClass("invalid");
        emailfield
          .parents("li")
          .removeClass("list-valid")
          .addClass("list-invalid");
        if (pcallback != null) return pcallback.call(this, false);
      } else {
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(emailfield.val()) == false) {
          $(emailfield)
            .removeClass("valid")
            .removeClass("processing")
            .addClass("invalid")
            .addClass("api-error");
          emailfield
            .parents("li")
            .removeClass("list-valid")
            .addClass("list-invalid");
          $(emailfield).focus();
          inpsubmit.attr("disabled", "disabled");
          if (pcallback != null) return pcallback.call(this, false);
        } else {
          emailfield
            .removeClass("invalid")
            .removeClass("valid")
            .addClass("processing");
          inpsubmit.attr("disabled", "disabled");
          _THIS.emailValidator(emailfield.val(), function (json) {
            emailfield.removeClass("processing");
            inpsubmit.prop("disabled", false);

            if (typeof json.status != "undefined") {
              // valid addresses have a {200, 207, 215} result
              // result codes 114 and 118 need a retry
              var statuscode = json.status;
              if (
                statuscode == "114" ||
                statuscode == "118" ||
                statuscode == "119" ||
                statuscode == "121" ||
                statuscode == "200" ||
                statuscode == "207" ||
                statuscode == "215" ||
                statuscode == "308" ||
                statuscode == "317"
              ) {
                emailfield.removeClass("invalid").addClass("valid");
                emailfield
                  .parents("li")
                  .removeClass("list-invalid")
                  .addClass("list-valid");
                _THIS.emailRetryCounter = 0;
                if (pcallback != null) return pcallback.call(this, true);
              } else if (statuscode == "313") {
                if (_THIS.emailRetryCounter < 5) {
                  _THIS.emailRetryCounter++;
                  emailfield.trigger("blur");
                } else {
                  emailfield
                    .removeClass("valid")
                    .addClass("invalid")
                    .addClass("api-error");
                  emailfield
                    .parents("li")
                    .removeClass("list-valid")
                    .addClass("list-invalid");
                  inpsubmit.attr("disabled", "disabled");
                  if (pcallback != null) return pcallback.call(this, false);
                }
              } else {
                _THIS.emailRetryCounter = 0;
                emailfield
                  .removeClass("valid")
                  .addClass("invalid")
                  .addClass("api-error");
                emailfield
                  .parents("li")
                  .removeClass("list-valid")
                  .addClass("list-invalid");
                inpsubmit.attr("disabled", "disabled");
                if (pcallback != null) return pcallback.call(this, false);
              }
            } else {
              //problem with the API
              emailfield
                .removeClass("valid")
                .addClass("invalid")
                .addClass("api-error");
              emailfield
                .parents("li")
                .removeClass("list-valid")
                .addClass("list-invalid");
              inpsubmit.attr("disabled", "disabled");
              if (pcallback != null) return pcallback.call(this, true);
            }
          });
        } //
      }
    });
  };

  this.emailValidator = function (pemailAddress, pcallback) {
    $.ajax({
      url: "//api.email-validator.net/api/verify",
      type: "POST",
      cache: false,
      crossDomain: true,
      data: {
        EmailAddress: pemailAddress,
        APIKey: theme.devSettings.emailApiKey,
      },
      dataType: "json",
      success: function (json) {
        if (pcallback != null) return pcallback.call(this, json);
      },
      error: function (xhr, status, error) {
        var err = JSON.parse(xhr.responseText);
        if (pcallback != null) return pcallback.call(this, err);
      },
    });
  };
}

export function phoneValidate() {
  var _THIS = this;
  this.init = function (
    phonefeldstr,
    isphonefeldMandatory,
    inpsubmit,
    pcallback
  ) {
    $(document).on("blur", phonefeldstr, function (e) {
      var phonefeld = $(this);
      var phonePattern = /^0[0-8]\d{8}$/g;
      if (phonefeld.val() == "") {
        if (isphonefeldMandatory) {
          phonefeld
            .removeClass("valid")
            .addClass("invalid")
            .addClass("api-error");
          phonefeld
            .parents("li")
            .removeClass("list-valid")
            .addClass("list-invalid");
          if (pcallback != null) return pcallback.call(this, false);
        } else {
          phonefeld.removeClass("valid").removeClass("invalid");
          phonefeld
            .parents("li")
            .removeClass("list-valid")
            .removeClass("list-invalid");
          if (pcallback != null) return pcallback.call(this, true);
        }
      } else {
        //Exception to field validation in specific areas
        if (phonefeldstr == "#checkout_billing_address_phone") {
          if (
            typeof $("#checkout_billing_address_country option:selected").attr(
              "data-code"
            ) !== "undefined"
          ) {
            if (
              $("#checkout_billing_address_country option:selected").attr(
                "data-code"
              ) !== theme.devSettings.countrycode
            ) {
              phonefeld.removeClass("valid").removeClass("invalid");
              phonefeld
                .parents("li")
                .removeClass("list-valid")
                .removeClass("list-invalid");
              if (pcallback != null) return pcallback.call(this, true);
            }
          }
        }

        if ($("body").hasClass("template-customers")) {
          //console.log("step 1: " +  phonefeldstr)
          if (phonefeldstr.indexOf("address[phone]") !== -1) {
            //console.log("step 2")
            var selCountry = phonefeld
              .closest("form")
              .find("select[name='address[country]']");
            //console.log(selCountry)
            if (
              selCountry.find("option:selected").attr("value") !==
              theme.devSettings.countryname
            ) {
              phonefeld.removeClass("valid").removeClass("invalid");
              phonefeld
                .parents("li")
                .removeClass("list-valid")
                .removeClass("list-invalid");
              if (pcallback != null) return pcallback.call(this, true);
            }
          }
        }

        phonefeld
          .removeClass("invalid")
          .removeClass("valid")
          .addClass("processing");
        inpsubmit.attr("disabled", "disabled");

        _THIS.phoneValidator(phonefeld, phonefeld.val(), function (json) {
          phonefeld.removeClass("processing");
          var label = "Intersport-" + theme.devSettings.countrycode;
          if (typeof json.status != "undefined") {
            var statuscode = json.status;
            switch (statuscode) {
              case "VALID_CONFIRMED":
              case "VALID_UNCONFIRMED":
              case "DELAYED":
                phonefeld
                  .removeClass("invalid")
                  .addClass("valid")
                  .parent()
                  .find("span.fa")
                  .remove();
                phonefeld
                  .parents("li")
                  .removeClass("list-invalid")
                  .addClass("list-valid");
                inpsubmit.prop("disabled", false);
                if (pcallback != null) return pcallback.call(this, true);

                break;
              case "INVALID":
              default:
                phonefeld
                  .removeClass("valid")
                  .addClass("invalid")
                  .addClass("api-error"); //.parent().find('span.fa').remove();
                phonefeld
                  .parents("li")
                  .removeClass("list-valid")
                  .addClass("list-invalid");
                inpsubmit.attr("disabled", "disabled");
                if (pcallback != null) return pcallback.call(this, false);
            }
          } else {
            phonefeld
              .removeClass("valid")
              .addClass("invalid")
              .addClass("api-error"); //.parent().find('span.fa').remove();
            phonefeld
              .parents("li")
              .removeClass("list-valid")
              .addClass("list-invalid");
            inpsubmit.attr("disabled", "disabled");
            if (pcallback != null) return pcallback.call(this, false);
          }
        });
      }
    });
  };

  this.phoneValidator = function (phonefeld, pphonenumber, pcallback) {
    var apiData = {
      PhoneNumber: pphonenumber,
      Locale: theme.devSettings.language,
      APIKey: theme.devSettings.phoneApiKey,
    };

    if (pphonenumber.indexOf("+") == -1) {
      apiData.CountryCode = theme.devSettings.countrycode.toLowerCase();
    }

    //ajaxPhoneValidInst =
    $.ajax({
      url: "//api.phone-validator.net/api/v2/verify",
      type: "POST",
      cache: false,
      crossDomain: true,
      data: apiData,
      dataType: "json",
      success: function (json) {
        if (pcallback != null) return pcallback.call(this, json);
      },
    });
  };
}

//
export function carousel() {
  var _THIS = this;

  this.elementContainer = null;
  this.init = function (elem) {
    _THIS.elementContainer = elem;

    //We make sure we target the right container

    initPromoFlags(_THIS.elementContainer + " .product-item-promo-flag");
    initPromoNames(_THIS.elementContainer + " .product-item-promo-name");

    //Check if there are slides to initialise
    //console.log(_THIS.elementContainer + "  " + $(_THIS.elementContainer + " .wrap-inner-slideshow .slide").length)
    if (
      $(_THIS.elementContainer + " .wrap-inner-slideshow .slide").length <= 0
    ) {
      return;
    }

    //console.log(_THIS.elementContainer)
    registerEvents();
    checkCarouselNavigation();
  };

  var registerEvents = function () {
    $(document).on(
      "click",
      _THIS.elementContainer + " .block-navigation .next",
      function (e) {
        e.preventDefault();
        _THIS.moveCarousel("next");
      }
    );

    $(document).on(
      "click",
      _THIS.elementContainer + " .block-navigation .prev",
      function (e) {
        e.preventDefault();
        _THIS.moveCarousel("prev");
      }
    );
  };

  var checkCarouselNavigation = function () {
    var container = $(_THIS.elementContainer + " .wrap-slideshow");
    var slider = $(_THIS.elementContainer + " .wrap-inner-slideshow");
    var slideWidth = slider.find(".slide").eq(0).width();
    var containerwidth = container.width();
    var scrollWidth = slideWidth * slider.find(".slide").length;
    scrollWidth = Math.floor(scrollWidth); //to prevent decimal

    var targetContainer = $(_THIS.elementContainer);

    if (targetContainer.hasClass("shopify-section")) {
      targetContainer = $(_THIS.elementContainer + " .carousel");
    } else {
      if ($(_THIS.elementContainer + " .carousel").length > 0) {
        targetContainer = $(_THIS.elementContainer + " .carousel").eq(0);
      }
    }

    //console.log(_THIS.elementContainer  + "   " + scrollWidth + " "  + containerwidth)

    if (scrollWidth <= containerwidth) {
      targetContainer.addClass("disable-navigation");
    } else {
      targetContainer.removeClass("disable-navigation");
    }
    //console.log(_THIS.elementContainer + "   scrollWidth: " + scrollWidth +  "    " + "containerwidth: " + containerwidth)
  };

  this.moveCarousel = function (action) {
    var container = $(_THIS.elementContainer + " .wrap-slideshow");
    var slider = $(_THIS.elementContainer + " .wrap-inner-slideshow");
    var slideWidth = slider.find(".slide").eq(0).width();

    //Check current scroll position
    var containerwidth = container.width();
    var scrollWidth = slideWidth * slider.find(".slide").length;
    scrollWidth = Math.floor(scrollWidth); //to prevent decimal
    var scrollcontent = containerwidth + container.scrollLeft();

    if (action == "next") {
      if (scrollcontent >= scrollWidth) {
        container.scrollLeft(0);
        return;
      }
    } else {
      //prev
      if (container.scrollLeft() <= 0) {
        container.scrollLeft(scrollWidth);
        return;
      }
    }
    //console.log((action=="next"?(container.scrollLeft() + slideWidth): (container.scrollLeft() - slideWidth)))

    $(container).animate(
      {
        scrollLeft:
          action == "next"
            ? container.scrollLeft() + slideWidth
            : container.scrollLeft() - slideWidth,
      },
      300,
      function () {
        //complete scrolling
      }
    );
  };
}

export function initComingSoonAddButton(container){
  
  
  var isComingSoonAttrib = $(container).find(".product-control-add").attr("data-iscomingsoon")
  var isComingSoonEAttrib = $(container).find(".product-control-add").attr("data-iscomingsoon-edate")
  var isComingSoonObj = checkComingSoonActive(isComingSoonAttrib,isComingSoonEAttrib)
  $(container + " .product-form-controls button[name=add]").prop("disabled",true);
  if(isComingSoonObj.isComingSoon){
    
    $(container).find(".cartTxtComingSoon").removeClass("hide")
    $(container).find(".addToCartText").addClass("hide")
    $(container).find(".available-from").text(isComingSoonObj.endDate)
    $(container).addClass("comingsoonactive")
    $(container + " .product-form-controls button[name=add]").removeClass("btn")

  }else{
    $(container).find(".cartTxtComingSoon").addClass("hide")
    $(container).find(".addToCartText").removeClass("hide")
    $(container).find(".available-from").text("")
    $(container).removeClass("comingsoonactive")
    $(container + " .product-form-controls button[name=add]").addClass("btn")
  }

}  



export function checkComingSoonActive(attComingSoon,attComingSoonDateString){

  //set to true date display will be formatted to local date time 
  //false we will just use a split string on promo tag comingSoonEnd
  var useFormattedToLocalDate = true; 
  
  
  var localTimeZone = 'Australia/Melbourne';
  var options = { timeZone: localTimeZone , month: 'numeric',day: 'numeric', year: 'numeric', hour: "2-digit", minute: "2-digit",  second: "2-digit"  };
  var currentLocalTime = new Date().toLocaleDateString('en-AU', options, options);
  var end = new Date(attComingSoonDateString)
  var arrCountryTime = currentLocalTime.split(",")

  var retObj = {
    isComingSoon:false,
    endDate:""
  }

  
  if(attComingSoon == "true" && arrCountryTime.length >= 2){

    var datePart = arrCountryTime[0]
    var arrBrisDate = datePart.split("/")
    var daypart =  arrBrisDate[0]
    var monthpart=  arrBrisDate[1]
    var yearpart=  arrBrisDate[2]

    var newStringBrisTime = monthpart + '/' + daypart + '/'  + yearpart;
    var newFullStringBrisTime = newStringBrisTime + ',' + arrCountryTime[1];
    var currentBrisDate = new Date(newFullStringBrisTime);

    if(!(currentBrisDate instanceof Date && !isNaN(currentBrisDate))){
      currentBrisDate = new Date(currentLocalTime);
    }

    if(currentBrisDate<= end){
        retObj.isComingSoon = true
        if(useFormattedToLocalDate){
          retObj.endDate = new Date(end).toLocaleDateString()
        }else{
          retObj.endDate = attComingSoonDateString.split(" ")[0]
        }
        


        //

    }else{
      retObj.isComingSoon = false
      retObj.endDate = ""
    }
  
  }
  return retObj;

}


export function initComingSoonFlag(container){
  var searchObject = null;
  if (typeof container == "string") {
    searchObject = $(container);
  } else {
    searchObject = container;
  }
  searchObject.each(function () {

    var isComingSoonAttrib = $(this).attr("data-iscomingsoon")
    var isComingSoonEAttrib = $(this).attr("data-iscomingsoon-edate")
    var isComingSoonObj = checkComingSoonActive(isComingSoonAttrib,isComingSoonEAttrib)
  
    if(isComingSoonObj.isComingSoon){
    
     $(this).removeClass("hide")
     $(this).parent().find(".available-from-item").text(isComingSoonObj.endDate)
  
    }else{
      $(this).parent().find(".available-from-item").text("")
      $(this).addClass("hide")
    }

  });
}


export function initPromoFlags(container) {
  var searchObject = null;
  if (typeof container == "string") {
    searchObject = $(container);
  } else {
    searchObject = container;
  }
  searchObject.each(function () {
    var promostart = $(this).attr("data-promo-start");
    var promoend = $(this).attr("data-promo-end");
    var _THIS = $(this);
    try {
      var options = {
        timeZone: theme.devSettings.regional,
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      var currentBrisbaneTime = new Date().toLocaleDateString(
        theme.devSettings.language,
        options,
        options
      );
      var start = new Date(promostart);
      var end = new Date(promoend);

      var arrCountryTime = currentBrisbaneTime.split(",");

      if (arrCountryTime.length >= 2) {
        var datePart = arrCountryTime[0];
        var arrBrisDate = datePart.split("/");
        var daypart = arrBrisDate[0];
        var monthpart = arrBrisDate[1];
        var yearpart = arrBrisDate[2];

        var newStringBrisTime = monthpart + "/" + daypart + "/" + yearpart;
        var newFullStringBrisTime = newStringBrisTime + "," + arrCountryTime[1];
        var currentBrisDate = new Date(newFullStringBrisTime);

        if (!(currentBrisDate instanceof Date && !isNaN(currentBrisDate))) {
          var currentBrisDate = new Date(currentBrisbaneTime);
        }

        // console.log(currentBrisDate)
        // console.log(start + "  " + end)
        if (_THIS.text().length > 1) {
          if (currentBrisDate >= start && currentBrisDate <= end) {
            _THIS.removeClass("hide");
            _THIS.parent().find(".product-item-flag").addClass("hide");
          } else {
            _THIS.parent().find(".product-item-flag").removeClass("hide");
          }
        }
      } else {
        if (_THIS.text().length > 1) {
          _THIS.parent().find(".product-item-flag").removeClass("hide");
        }
        return;
      }
    } catch (err) {
      //console.log(err)
      if (_THIS.text().length > 1) {
        _THIS.parent().find(".product-item-flag").removeClass("hide");
      }
      return;
    }
  });
}

export function initPromoNames(container) {
  var searchObject = null;
  if (typeof container == "string") {
    searchObject = $(container);
  } else {
    searchObject = container;
  }
  searchObject.each(function () {
    var promostart = $(this).attr("data-promo-start");
    var promoend = $(this).attr("data-promo-end");
    var _THIS = $(this);
    try {
      var options = {
        timeZone: theme.devSettings.regional,
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      var currentBrisbaneTime = new Date().toLocaleDateString(
        theme.devSettings.language,
        options
      );
      var start = new Date(promostart);
      var end = new Date(promoend);

      var arrCountryTime = currentBrisbaneTime.split(",");
      if (arrCountryTime.length >= 2) {
        var datePart = arrCountryTime[0];
        var arrBrisDate = datePart.split("/");
        var daypart = arrBrisDate[0];
        var monthpart = arrBrisDate[1];
        var yearpart = arrBrisDate[2];

        var newStringBrisTime = monthpart + "/" + daypart + "/" + yearpart;
        var newFullStringBrisTime = newStringBrisTime + "," + arrCountryTime[1];
        var currentBrisDate = new Date(newFullStringBrisTime);

        if (!(currentBrisDate instanceof Date && !isNaN(currentBrisDate))) {
          var currentBrisDate = new Date(currentBrisbaneTime);
        }

        if (currentBrisDate >= start && currentBrisDate <= end) {
          _THIS.removeClass("hide");
        } else {
          _THIS.parent().find(".product-item-flag").removeClass("hide");
        }
      } else {
        return;
      }
    } catch (err) {
      //console.log(err)
      return;
    }
  });
}

export function setFancyConfirm(pcallback) {
  checkLibrary($.fancybox, theme.components.modalLibraryURL, function () {
    $.fancyConfirm = function (opts) {
      opts = $.extend(
        true,
        {
          title: "Are you sure?",
          message: "",
          okButton: "OK",
          noButton: "CANCEL",
          callback: $.noop,
        },
        opts || {}
      );

      $.fancybox.open({
        type: "html",
        src:
          '<div class="fc-content align-center">' +
          "<h2>" +
          opts.title.toUpperCase() +
          "</h2>" +
          "<p>" +
          opts.message +
          "</p>" +
          '<div class="action-buttons">' +
          '<a class="btn btn-error outline sm smallBtn technical-01-medium" data-value="0" data-fancybox-close>' +
          opts.noButton.toUpperCase() +
          "</a>&nbsp;" +
          '<button data-value="1" data-fancybox-close class="btn btn-primary sm smallBtn technical-01-medium">' +
          opts.okButton.toUpperCase() +
          "</button>" +
          "</div>" +
          "</div>",
        opts: {
          animationDuration: 350,
          animationEffect: "material",
          modal: true,
          baseTpl:
            '<div class="fancybox-container fc-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-stage"></div>' +
            "</div>" +
            "</div>",
          afterClose: function (instance, current, e) {
            var button = e ? e.target || e.currentTarget : null;
            var value = button ? $(button).data("value") : 0;

            opts.callback(value);
          },
        },
      });
    };

    if (pcallback != null) return pcallback.call(this);
  });
}

/** Load Library on Demand  */
export function checkLibrary(library, libraryurl, callback) {
  if (typeof library == "undefined") {
    // we do not load fancy lib on page load but on quickview link (if lib not loaded yet)

    const script = document.createElement("script");
    script.src = libraryurl;

    // Append to the `head` element
    document.head.appendChild(script);
    script.addEventListener("load", function () {
      if (callback != null) return callback.call(this);
    });
  } else {
    if (callback != null) return callback.call(this);
  }
}

/**
 * Contact Us form
 */
export function contactForm() {
  var _THIS = this;
  this.emailhasValidated = false;
  this.formString = "#ContactForm";
  this.form = $(_THIS.formString);

  this.init = function () {
    registerEvents();
    (async () => {
      //const { styleForm } = await import(theme.components.commonURL);
      var instStyleForm = new styleForm();
      instStyleForm.init();
    })();
  };

  var registerEvents = function () {
    //initialise the email validation

    var instEmailValidate = new emailValidate();
    instEmailValidate.init(
      $("#ContactForm-email"),
      _THIS.form.find("input[type=submit]"),
      function (isemailvalid) {
        _THIS.emailhasValidated = isemailvalid;

        if (_THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }
      }
    );

    if ($("#ContactForm-email").val() !== "") {
      $("#ContactForm-email").trigger("blur");
    }

    //
    $(document).on(
      "click",
      _THIS.formString + " input[type=submit]",
      function (e) {
        _THIS.submitForm(e);
      }
    );
  };

  this.submitForm = function (e) {
    var validFormResult = _THIS.validateForm();
    e.preventDefault();
    if (!validFormResult.isFormValid) {
      _THIS.displayFormErrors(validFormResult.messages.error);
    } else {
      _THIS.form.submit();
    }
  };

  this.validateForm = function () {
    _THIS.hideFormErrors();

    var retObj = {
      isFormValid: true,
      messages: {
        error: [],
        success: [],
      },
    };

    var mandatoryFields = ["#ContactForm-email"];

    for (var i = 0; i < mandatoryFields.length; i++) {
      var fld = _THIS.form.find(mandatoryFields[i]);
      var fldVal = fld.val();
      if ($.trim(fldVal).length <= 0) {
        fld.addClass("invalid");
        retObj.isFormValid = false;
      } else {
        fld.removeClass("invalid");
      }
    }

    if (!_THIS.form.find("#ContactForm-email").hasClass("valid")) {
      _THIS.form.find("#ContactForm-email").addClass("invalid");
      retObj.isFormValid = false;
    }

    if (!retObj.isFormValid) {
      retObj.messages.error.push(theme.forms.general.mandatory);
    }

    return retObj;
  };

  this.displayFormErrors = function (arrErrors) {
    var htmlErrorList = "";
    for (var i = 0; i < arrErrors.length; i++) {
      htmlErrorList += "<li>" + arrErrors[i] + "</li>";
    }

    if (htmlErrorList !== "") {
      _THIS.form
        .find(".form-message")
        .removeClass("form-message--error")
        .removeClass("form-message--success");
      _THIS.form
        .find(".form-message .form-message-inner")
        .html("<ul>" + htmlErrorList + "</ul>");

      _THIS.form.find(".form-message").addClass("form-message--error");
      _THIS.form.find(".form-message").removeClass("hide");
    }
  };

  this.hideFormErrors = function () {
    _THIS.form.find(".form-message").addClass("hide");
    _THIS.form
      .find(".form-message")
      .removeClass("form-message--error")
      .removeClass("form-message--success");
    _THIS.form.find(".form-message .form-message-inner").html("");
  };
}

/**
 * New Store Enquiry Form
 */
export function storeEnquiryForm() {
  var _THIS = this;
  this.emailhasValidated = false;
  this.formString = "#storeEnquiryForm";
  this.form = $(_THIS.formString);

  this.init = function () {
    registerEvents();
    (async () => {
      //const { styleForm } = await import(theme.components.commonURL);
      var instStyleForm = new styleForm();
      instStyleForm.init();
    })();
  };

  var registerEvents = function () {
    //initialise the email validation
    if ($("#storeEnquiryForm-phone").length > 0) {
      $(document).on("focus", "#storeEnquiryForm-phone", function () {
        if ($(this).val().length == 0) {
          $(this).val(theme.devSettings.phoneCountryCode);
        }
      });

      var instPhoneValidate = new phoneValidate();
      instPhoneValidate.init(
        "#storeEnquiryForm-phone",
        false,
        _THIS.form.find("input[type=submit]"),
        function (isphonevalid) {
          _THIS.phonehasValidated = isphonevalid;
          if (_THIS.phonehasValidated && _THIS.emailhasValidated) {
            _THIS.form.find("input[type=submit]").prop("disabled", false);
          }
        }
      );
    }

    var instEmailValidate = new emailValidate();
    instEmailValidate.init(
      $("#storeEnquiryForm-email"),
      _THIS.form.find("input[type=submit]"),
      function (isemailvalid) {
        _THIS.emailhasValidated = isemailvalid;

        if ($("#storeEnquiryForm-phone").length <= 0) {
          _THIS.phonehasValidated = true;
        }

        if (_THIS.phonehasValidated && _THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }

        if (_THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }
      }
    );

    if ($("#storeEnquiryForm-email").val() !== "") {
      $("#storeEnquiryForm-email").trigger("blur");
    }
    //
    $(document).on(
      "click",
      _THIS.formString + " input[type=submit]",
      function (e) {
        _THIS.submitForm(e);
      }
    );
  };

  this.submitForm = function (e) {
    var validFormResult = _THIS.validateForm();
    e.preventDefault();
    if (!validFormResult.isFormValid) {
      _THIS.displayFormErrors(validFormResult.messages.error);
    } else {
      _THIS.form.submit();
    }
  };

  this.validateForm = function () {
    _THIS.hideFormErrors();

    var retObj = {
      isFormValid: true,
      messages: {
        error: [],
        success: [],
      },
    };

    var mandatoryFields = [
      "#storeEnquiryForm-firstname",
      "#storeEnquiryForm-lastname",
      "#storeEnquiryForm-email",
      "#storeEnquiryForm-phone",
      "#storeEnquiryForm-address",
      "#storeEnquiryForm-message",
    ];

    for (var i = 0; i < mandatoryFields.length; i++) {
      var fld = _THIS.form.find(mandatoryFields[i]);
      var fldVal = fld.val();
      if ($.trim(fldVal).length <= 0) {
        fld.addClass("invalid");
        retObj.isFormValid = false;
      } else {
        fld.removeClass("invalid");
      }
    }

    if (_THIS.form.find("#storeEnquiryForm-phone").length > 0) {
      if (!_THIS.form.find("#storeEnquiryForm-phone").hasClass("valid")) {
        _THIS.form.find("#storeEnquiryForm-phone").addClass("invalid");
        _THIS.form
          .find("#storeEnquiryForm-phone")
          .parents("li")
          .removeClass("list-valid")
          .addClass("list-invalid");
        retObj.isFormValid = false;
      }
    }

    if (!_THIS.form.find("#storeEnquiryForm-email").hasClass("valid")) {
      _THIS.form.find("#storeEnquiryForm-email").addClass("invalid");
      retObj.isFormValid = false;
    }

    if (!retObj.isFormValid) {
      retObj.messages.error.push(theme.forms.general.mandatory);
    }

    return retObj;
  };

  this.displayFormErrors = function (arrErrors) {
    var htmlErrorList = "";
    for (var i = 0; i < arrErrors.length; i++) {
      htmlErrorList += "<li>" + arrErrors[i] + "</li>";
    }

    if (htmlErrorList !== "") {
      _THIS.form
        .find(".form-message")
        .removeClass("form-message--error")
        .removeClass("form-message--success");
      _THIS.form
        .find(".form-message .form-message-inner")
        .html("<ul>" + htmlErrorList + "</ul>");

      _THIS.form.find(".form-message").addClass("form-message--error");
      _THIS.form.find(".form-message").removeClass("hide");
    }
  };

  this.hideFormErrors = function () {
    _THIS.form.find(".form-message").addClass("hide");
    _THIS.form
      .find(".form-message")
      .removeClass("form-message--error")
      .removeClass("form-message--success");
    _THIS.form.find(".form-message .form-message-inner").html("");
  };
}

/**
 * New Supplier Enquiry Form
 */
export function supplierEnquiryForm() {
  var _THIS = this;
  this.emailhasValidated = false;
  this.formString = "#supplierEnquiryForm";
  this.form = $(_THIS.formString);

  this.init = function () {
    registerEvents();
    (async () => {
      //const { styleForm } = await import(theme.components.commonURL);
      var instStyleForm = new styleForm();
      instStyleForm.init();
    })();
  };

  var registerEvents = function () {
    //initialise the email validation
    if ($("#supplierEnquiryForm-phone").length > 0) {
      $(document).on("focus", "#supplierEnquiryForm-phone", function () {
        if ($(this).val().length == 0) {
          $(this).val(theme.devSettings.phoneCountryCode);
        }
      });

      var instPhoneValidate = new phoneValidate();
      instPhoneValidate.init(
        "#supplierEnquiryForm-phone",
        false,
        _THIS.form.find("input[type=submit]"),
        function (isphonevalid) {
          _THIS.phonehasValidated = isphonevalid;
          if (_THIS.phonehasValidated && _THIS.emailhasValidated) {
            _THIS.form.find("input[type=submit]").prop("disabled", false);
          }
        }
      );
    }

    var instEmailValidate = new emailValidate();
    instEmailValidate.init(
      $("#supplierEnquiryForm-email"),
      _THIS.form.find("input[type=submit]"),
      function (isemailvalid) {
        _THIS.emailhasValidated = isemailvalid;

        if ($("#supplierEnquiryForm-phone").length <= 0) {
          _THIS.phonehasValidated = true;
        }

        if (_THIS.phonehasValidated && _THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }

        if (_THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }
      }
    );

    if ($("#supplierEnquiryForm-email").val() !== "") {
      $("#supplierEnquiryForm-email").trigger("blur");
    }
    //
    $(document).on(
      "click",
      _THIS.formString + " input[type=submit]",
      function (e) {
        _THIS.submitForm(e);
      }
    );
  };

  this.submitForm = function (e) {
    var validFormResult = _THIS.validateForm();
    e.preventDefault();
    if (!validFormResult.isFormValid) {
      _THIS.displayFormErrors(validFormResult.messages.error);
    } else {
      _THIS.form.submit();
    }
  };

  this.validateForm = function () {
    _THIS.hideFormErrors();

    var retObj = {
      isFormValid: true,
      messages: {
        error: [],
        success: [],
      },
    };

    var mandatoryFields = [
      "#supplierEnquiryForm-name",
      "#supplierEnquiryForm-email",
    ];

    for (var i = 0; i < mandatoryFields.length; i++) {
      var fld = _THIS.form.find(mandatoryFields[i]);
      var fldVal = fld.val();
      if ($.trim(fldVal).length <= 0) {
        fld.addClass("invalid");
        retObj.isFormValid = false;
      } else {
        fld.removeClass("invalid");
      }
    }

    if (_THIS.form.find("#supplierEnquiryForm-phone").length > 0) {
      if (!_THIS.form.find("#supplierEnquiryForm-phone").hasClass("valid")) {
        _THIS.form.find("#supplierEnquiryForm-phone").addClass("invalid");
        _THIS.form
          .find("#supplierEnquiryForm-phone")
          .parents("li")
          .removeClass("list-valid")
          .addClass("list-invalid");
        retObj.isFormValid = false;
      }
    }

    if (!_THIS.form.find("#supplierEnquiryForm-email").hasClass("valid")) {
      _THIS.form.find("#supplierEnquiryForm-email").addClass("invalid");
      retObj.isFormValid = false;
    }

    if (!retObj.isFormValid) {
      retObj.messages.error.push(theme.forms.general.mandatory);
    }

    return retObj;
  };

  this.displayFormErrors = function (arrErrors) {
    var htmlErrorList = "";
    for (var i = 0; i < arrErrors.length; i++) {
      htmlErrorList += "<li>" + arrErrors[i] + "</li>";
    }

    if (htmlErrorList !== "") {
      _THIS.form
        .find(".form-message")
        .removeClass("form-message--error")
        .removeClass("form-message--success");
      _THIS.form
        .find(".form-message .form-message-inner")
        .html("<ul>" + htmlErrorList + "</ul>");

      _THIS.form.find(".form-message").addClass("form-message--error");
      _THIS.form.find(".form-message").removeClass("hide");
    }
  };

  this.hideFormErrors = function () {
    _THIS.form.find(".form-message").addClass("hide");
    _THIS.form
      .find(".form-message")
      .removeClass("form-message--error")
      .removeClass("form-message--success");
    _THIS.form.find(".form-message .form-message-inner").html("");
  };
}

export function recentlyViewed() {
  var _THIS = this;

  this.elementContainer = null;
  this.init = function (elem) {
    _THIS.elementContainer = elem;
    generateRecentlyProducts();
  };

  var generateRecentlyProducts = function () {
    var recentlyProducts = _THIS.getRecentlyViewed();

    var visibleProducts = 4;
    //reformat array to array objecs

    if (recentlyProducts.length > 0) {
      $(_THIS.elementContainer).find(".carousel").removeClass("hide");

      /*var elVisileProducts = $(_THIS.elementContainer).find(".carousel").attr("data-visible-products")
            if(typeof(elVisileProducts)!=="undefined"){
                visibleProducts = elVisileProducts;
            }*/

      /*if(recentlyProducts.length < visibleProducts ){
                $(_THIS.elementContainer).find(".carousel").addClass("disable-navigation")
            }*/
      getProductsInformation(recentlyProducts, false, function (data) {
        //$( _THIS.elementContainer).html(data);
        var htmlData = "";
        for (var i = 0; i < data.length; i++) {
          htmlData += data[i].response;
        }
        $(_THIS.elementContainer).find(".wrap-inner-slideshow").html(htmlData);

        var insRecentlyCarousel = new carousel();
        insRecentlyCarousel.init(_THIS.elementContainer);

        $(
          _THIS.elementContainer + " .product-item-swatches .cycle-slideshow"
        ).cycle();

        (async () => {
          const { default: models } = await import(theme.components.modelsURL);

          models.updateModelsDisplay(
            _THIS.elementContainer + " .product-media"
          );
        })();
      });
    } else {
      $(_THIS.elementContainer).find(".carousel").addClass("hide");
      //$(_THIS.elementContainer).find(".carousel").removeClass("disable-navigation")
    }
  };

  this.saveRecentlyViewed = function (handle) {
    var getRecently = this.getRecentlyViewed();

    var position = $.inArray(handle, getRecently);

    if (position === -1) {
      // Add product at the start of the list.
      getRecently.unshift(handle);
      // Only keep what we need.
      getRecently = getRecently.splice(0, 20);
    } else {
      // Remove the product and place it at start of list.
      getRecently.splice(position, 1);
      getRecently.unshift(handle);
    }

    Cookies.set("shopify_recently_viewed", getRecently.join(" "), 365);
  };

  this.getRecentlyViewed = function () {
    var retCently = [];
    var getRetC = Cookies.get("shopify_recently_viewed");

    if (typeof getRetC !== "undefined" && getRetC !== "") {
      retCently = getRetC.split(" ");
    }
    return retCently;
  };
}

/**
 * Join Intersport Club Form
 */
export function joinIntersportClub() {
  var _THIS = this;
  this.emailhasValidated = false;
  this.formString = "#joinIntersportClub";
  this.form = $(_THIS.formString);

  this.init = function () {
    registerEvents();
    (async () => {
      //const { styleForm } = await import(theme.components.commonURL);
      var instStyleForm = new styleForm();
      instStyleForm.init();
    })();
  };

  var registerEvents = function () {
    //initialise the email validation
    if ($("#joinIntersportClub-phone").length > 0) {
      $(document).on("focus", "#joinIntersportClub-phone", function () {
        if ($(this).val().length == 0) {
          $(this).val(theme.devSettings.phoneCountryCode);
        }
      });

      var instPhoneValidate = new phoneValidate();
      instPhoneValidate.init(
        "#joinIntersportClub-phone",
        false,
        _THIS.form.find("input[type=submit]"),
        function (isphonevalid) {
          _THIS.phonehasValidated = isphonevalid;
          if (_THIS.phonehasValidated && _THIS.emailhasValidated) {
            _THIS.form.find("input[type=submit]").prop("disabled", false);
          }
        }
      );
    }

    var instEmailValidate = new emailValidate();
    instEmailValidate.init(
      $("#joinIntersportClub-email"),
      _THIS.form.find("input[type=submit]"),
      function (isemailvalid) {
        _THIS.emailhasValidated = isemailvalid;

        if ($("#joinIntersportClub-phone").length <= 0) {
          _THIS.phonehasValidated = true;
        }

        if (_THIS.phonehasValidated && _THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }

        if (_THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }
      }
    );

    if ($("#joinIntersportClub-email").val() !== "") {
      $("#joinIntersportClub-email").trigger("blur");
    }
    //
    $(document).on(
      "click",
      _THIS.formString + " input[type=submit]",
      function (e) {
        _THIS.submitForm(e);
      }
    );
  };

  this.submitForm = function (e) {
    var validFormResult = _THIS.validateForm();
    e.preventDefault();
    if (!validFormResult.isFormValid) {
      _THIS.displayFormErrors(validFormResult.messages.error);
    } else {
      _THIS.form.submit();
    }
  };

  this.validateForm = function () {
    _THIS.hideFormErrors();

    var retObj = {
      isFormValid: true,
      messages: {
        error: [],
        success: [],
      },
    };

    var mandatoryFields = [
      "#joinIntersportClub-email",
      "#joinIntersportClub-firstname",
      "#joinIntersportClub-lastname",
      "#joinIntersportClub-phone",
      "#joinIntersportClub-postcode",
      "#genderSelect",
      "#localStoreSelect",
    ];

    for (var i = 0; i < mandatoryFields.length; i++) {
      var fld = _THIS.form.find(mandatoryFields[i]);
      var fldVal = fld.val();
      if ($.trim(fldVal).length <= 0) {
        fld.addClass("invalid");
        retObj.isFormValid = false;
      } else if ("undefined" === typeof fldVal) {
        fld.addClass("invalid");
        retObj.isFormValid = false;
      } else {
        fld.removeClass("invalid");
      }
    }

    if (_THIS.form.find("#joinIntersportClub-phone").length > 0) {
      if (!_THIS.form.find("#joinIntersportClub-phone").hasClass("valid")) {
        _THIS.form.find("#joinIntersportClub-phone").addClass("invalid");
        _THIS.form
          .find("#joinIntersportClub-phone")
          .parents("li")
          .removeClass("list-valid")
          .addClass("list-invalid");
        retObj.isFormValid = false;
      }
    }

    if (!_THIS.form.find("#joinIntersportClub-email").hasClass("valid")) {
      _THIS.form.find("#joinIntersportClub-email").addClass("invalid");
      retObj.isFormValid = false;
    }

    if (!retObj.isFormValid) {
      retObj.messages.error.push(theme.forms.general.mandatory);
    }

    return retObj;
  };

  this.displayFormErrors = function (arrErrors) {
    var htmlErrorList = "";
    for (var i = 0; i < arrErrors.length; i++) {
      htmlErrorList += "<li>" + arrErrors[i] + "</li>";
    }

    if (htmlErrorList !== "") {
      _THIS.form
        .find(".form-message")
        .removeClass("form-message--error")
        .removeClass("form-message--success");
      _THIS.form
        .find(".form-message .form-message-inner")
        .html("<ul>" + htmlErrorList + "</ul>");

      _THIS.form.find(".form-message").addClass("form-message--error");
      _THIS.form.find(".form-message").removeClass("hide");
    }
  };

  this.hideFormErrors = function () {
    _THIS.form.find(".form-message").addClass("hide");
    _THIS.form
      .find(".form-message")
      .removeClass("form-message--error")
      .removeClass("form-message--success");
    _THIS.form.find(".form-message .form-message-inner").html("");
  };
}

export function getJsonProductInformation(phandle, callback) {
  $.ajax({
    type: "GET",
    url:
      window.Shopify.routes.root +
      "products/" +
      phandle +
      "?view=customproduct.json",
    success: function (response) {
      var json_response = JSON.parse(response);
      if (callback != null) return callback.call(this, json_response);
    },
    error: function (status) {
      console.warn("ERROR", status);
    },
  });
}
//Handling Multiple Ajax Request to get list of Product information
export function getProductsInformation(arrayHandles, usevalueprop, callback) {
  var requests = [];
  var responses = [];

  for (var i = 0; i < arrayHandles.length; i++) {
    requests.push(
      $.ajax({
        type: "GET",
        url:
          window.Shopify.routes.root +
          "products/" +
          (usevalueprop == true ? arrayHandles[i]["value"] : arrayHandles[i]) +
          "?view=card",
        h: usevalueprop == true ? arrayHandles[i]["value"] : arrayHandles[i],
        //theme.devSettings.requestLocale + '/products/' + arrayHandles[i]["value"] + '?view=customproduct.json',
        success: function (response) {
          var json_response = response; //JSON.parse(response);

          responses.push({ handle: this.h, response: json_response });
        },
      }).catch(function (jqXhr) {
        return {
          error: true,
          status: jqXhr.status,
          statusText: jqXhr.statusText,
        };
      })
    );
  }

  $.when.apply($, requests).done(function () {
    if (callback != null) return callback.call(this, responses);
  });
}

/**
 * Returns Enquiry Form
 */
export function returnsEnquiryForm() {
  var _THIS = this;
  this.emailhasValidated = false;
  this.formString = "#returnsEnquiryForm";
  this.form = $(_THIS.formString);

  this.init = function () {
    registerEvents();
    (async () => {
      //const { styleForm } = await import(theme.components.commonURL);
      var instStyleForm = new styleForm();
      instStyleForm.init();
    })();
  };

  var registerEvents = function () {
    var instEmailValidate = new emailValidate();
    instEmailValidate.init(
      $("#returnsEnquiryForm-email"),
      _THIS.form.find("input[type=submit]"),
      function (isemailvalid) {
        _THIS.emailhasValidated = isemailvalid;

        if (_THIS.emailhasValidated) {
          _THIS.form.find("input[type=submit]").prop("disabled", false);
        }
      }
    );

    if ($("#returnsEnquiryForm-email").val() !== "") {
      $("#returnsEnquiryForm-email").trigger("blur");
    }
    //
    $(document).on(
      "click",
      _THIS.formString + " input[type=submit]",
      function (e) {
        _THIS.submitForm(e);
      }
    );
  };

  this.submitForm = function (e) {
    var validFormResult = _THIS.validateForm();
    e.preventDefault();
    if (!validFormResult.isFormValid) {
      _THIS.displayFormErrors(validFormResult.messages.error);
    } else {
      _THIS.form.submit();
    }
  };

  this.validateForm = function () {
    _THIS.hideFormErrors();

    var retObj = {
      isFormValid: true,
      messages: {
        error: [],
        success: [],
      },
    };

    var mandatoryFields = [
      "#returnsEnquiryForm-name",
      "#returnsEnquiryForm-email",
      "#returnsEnquiryForm-orderno",
      "#returnsEnquiryForm-product_name",
      "#reasonForReturn",
    ];

    for (var i = 0; i < mandatoryFields.length; i++) {
      var fld = _THIS.form.find(mandatoryFields[i]);
      var fldVal = fld.val();
      console.log(fld);
      if ($.trim(fldVal).length <= 0) {
        fld.addClass("invalid");
        retObj.isFormValid = false;
      } else {
        fld.removeClass("invalid");
      }
    }

    if (!_THIS.form.find("#returnsEnquiryForm-email").hasClass("valid")) {
      _THIS.form.find("#returnsEnquiryForm-email").addClass("invalid");
      retObj.isFormValid = false;
    }

    if (!retObj.isFormValid) {
      retObj.messages.error.push(theme.forms.general.mandatory);
    }

    return retObj;
  };

  this.displayFormErrors = function (arrErrors) {
    var htmlErrorList = "";
    for (var i = 0; i < arrErrors.length; i++) {
      htmlErrorList += "<li>" + arrErrors[i] + "</li>";
    }

    if (htmlErrorList !== "") {
      _THIS.form
        .find(".form-message")
        .removeClass("form-message--error")
        .removeClass("form-message--success");
      _THIS.form
        .find(".form-message .form-message-inner")
        .html("<ul>" + htmlErrorList + "</ul>");

      _THIS.form.find(".form-message").addClass("form-message--error");
      _THIS.form.find(".form-message").removeClass("hide");
    }
  };

  this.hideFormErrors = function () {
    _THIS.form.find(".form-message").addClass("hide");
    _THIS.form
      .find(".form-message")
      .removeClass("form-message--error")
      .removeClass("form-message--success");
    _THIS.form.find(".form-message .form-message-inner").html("");
  };
}
